import * as bootstrap from 'bootstrap';

function initializePopovers(): void {

  // generic popover initialization
  const list = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
  list.map((el) => {
    let opts = {
      animation: true,
      content: el.getAttribute('data-bs-content'),
      html: false,
    }
    if (el.hasAttribute('data-bs-content-id')) {
      opts.content = document.getElementById(el.getAttribute('data-bs-content-id')).innerHTML;
      opts.html = true;
    }
    new bootstrap.Popover(el, opts);
  });

  // phone popover initialization
  const phonePopoverContentEl = document.getElementById('phonePopoverContent');
  if (phonePopoverContentEl) {
    let phonePopoverOpts = {
      animation: true,
      content: phonePopoverContentEl.innerHTML,
      html: true
    }
    const phonePopoverTriggers = [].slice.call(document.querySelectorAll('.header-bar-navigation .utility-navigation-item.phone-trigger'))
    phonePopoverTriggers.map((el) => {
      new bootstrap.Popover(el, phonePopoverOpts);
      el.getElementsByTagName("a")[0].attributes.removeNamedItem('href');
    });
  }
  
}

document.addEventListener('DOMContentLoaded', () => {
  initializePopovers();
});
